<app-resource-subtitle></app-resource-subtitle>
<div class="container gallery-wrapper">
    <app-media-gallery *ngIf="resource" [resource]="resource"></app-media-gallery>
</div>
<div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
        <app-resource-details></app-resource-details>
    </div>
    <div class="col-lg-4 recommended selenium-related-resources">
        <app-support-material-panel
            [resource]="resource"
            *ngIf="!windowSize.isTablet"
            style="margin-bottom: 30px"
        ></app-support-material-panel>
        <ng-container *ngIf="!isAddonView">
            <app-related-resources
                *ngIf="resource"
                [resource]="resource"
                class="selenium-you-may-also-like"
            ></app-related-resources>
            <app-curriculum-tags></app-curriculum-tags>
        </ng-container>
    </div>
</div>
<div class="row-auto" *ngIf="!isAddonView">
    <app-more-from-collection></app-more-from-collection>
</div>
